<p-button
  *appRights="[permissions.createApiUser]"
  label="Adaugă utilizator"
  icon="pi pi-plus"
  (click)="addUser()"
></p-button>

<p-table
  styleClass="p-datatable-sm mt-2"
  currentPageReportTemplate="{first} - {last} din {totalRecords} utilizatori"
  paginatorPosition="both"
  [totalRecords]="totalCount()"
  [paginator]="true"
  [rows]="filtersForm.get('pageSize')?.value"
  [value]="data()"
  [rowsPerPageOptions]="[25, 50, 100]"
  [showCurrentPageReport]="true"
  (onPage)="pageChanged($event)"
>
  <ng-template pTemplate="header">
    @if (loading()) {
      <tr>
        <td colspan="5">
          <p-progressBar mode="indeterminate" [style]="{'height': '6px'}" />
        </td>
      </tr>
    }
    <tr>
      <th>Client ID</th>
      <th>Descriere</th>
      <th>Rol</th>
      <th>Zonă</th>
      <th>Activitate</th>
      <th></th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-user>
    <tr>
      <td>{{ user.clientId }}</td>
      <td>{{ user.description }}</td>
      <td>
        <p class="m-0">
          <b>{{ user.role }}</b>
        </p>
        @if (user.roleExtensions.length) {
          <small class="text-xs">
            Extensii rol: {{ getMappedRoleExtensions(user) }}
          </small>
        }
      </td>
      <td>
        {{ getZoneName(user.zoneId) }}
      </td>
      <td>
        {{ getLastActiveMessage(user.lastUsedAt) }}
      </td>
      <td class="text-right">
        <p-menu
          styleClass="w-15rem"
          #userMenu
          appendTo="body"
          [tabindex]="undefined"
          [popup]="true"
          [model]="getUserMenuItems(user)"
        />
        <button
          pButton
          size="small"
          icon="pi pi-ellipsis-v"
          [plain]="true"
          [text]="true"
          [rounded]="true"
          (click)="userMenu.toggle($event)"
        ></button>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage">
      @if (!loading()) {
      <tr>
        <td colspan="5">
          <p class="text-center text-gray-400 text-xl font-bold">Nu există utilizatori</p>
        </td>
      </tr>
    }
  </ng-template>
</p-table>
